const userProfile = state => state.userProfile
const isAuthenticated = state => state.isAuthenticated
const isImpersonating = state => state.isImpersonating
const currentImpersonatedUser = state => state.currentImpersonatedUser
const isAdmin = state => state.isAdmin
const memberId = state => state.memberId
const userId = state => state.userId
const isAuthLoading = state => state.isAuthLoading
const isTwoFactorRequired = state => state.isTwoFactorRequired
const authProviders = state => state.authProviders
const redirectUrl = state => state.redirectUrl

export default {
  userProfile,
  isAuthenticated,
  isImpersonating,
  currentImpersonatedUser,
  isAdmin,
  memberId,
  userId,
  isAuthLoading,
  isTwoFactorRequired,
  authProviders,
  redirectUrl,
}
